import layout from '@/components/common/layout';
import studentList from '../views/student/list';
import studentCreate from "../views/student/create";

export default [
    {
        path: '/student',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "学生列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'student_list',// 子选项
                    }
                },
                component: studentList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增学生",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'student_list',// 子选项
                    }
                },
                component: studentCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑学生",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'student_list',// 子选项
                    }
                },
                component: studentCreate,
            },
        ]
    },
];
